export interface SkillInvokeAttributes {
  skillName?: string;
  hasContext: boolean;
  messageTextLength: number;
}

export interface ChannelSendAttributes {
  topicName: string;
  channelReady: boolean;
}

export interface AppContextUpdateAttributes {
  contextKeyCount: number;
  // Lazy so a no-op (or unsampled) implementation never pays the serialization cost.
  getContextSizeBytes: () => number;
}

/**
 * Optional telemetry seam for copilot-toolkit's page-to-agent boundary. A
 * consumer supplies an implementation via `<CopilotProvider telemetry={...}>`;
 * the OTel-backed one is `createCopilotTelemetry` in opentelemetry-fe. It is
 * injected rather than imported so copilot-toolkit takes on no OTel dependency,
 * and never dispatches a message, so it cannot drop a user's action.
 *
 * `skillInvoked` returns optional headers (e.g. a W3C `traceparent`) for the
 * caller to merge into the outgoing INVOKE_BREEZE_SKILL `turnMetadata`, so a
 * skill invoke can later be stitched to its backend turn
 * (fe-observability-ideas#1597).
 */
export interface CopilotTelemetry {
  skillInvoked(
    attributes: SkillInvokeAttributes
  ): Record<string, string> | undefined;
  skillInvokeDropped(reason: string): void;
  channelMessageSent(attributes: ChannelSendAttributes): void;
  appContextUpdated(attributes: AppContextUpdateAttributes): void;
}

export const noopCopilotTelemetry: CopilotTelemetry = {
  skillInvoked: () => undefined,
  skillInvokeDropped() {},
  channelMessageSent() {},
  appContextUpdated() {},
};
